import {
  valid,
  refreshToken,
  ajax,
  serviceAjax,
  header
} from './base'
import config from '../../config'

const charts = {
  async GetWorkBenchStatisticsInfo(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/WorkBench/GetStatisticsInfo',
      type: 'get',
      data
    })
    return response
  },
  async GetWorkBenchSalesInfoList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/WorkBench/GetSalesInfoList',
      type: 'get',
      data
    })
    return response
  },
}
export default charts



// WEBPACK FOOTER //
// ./src/common/api/charts.js